import React from "react";

import { bridge } from "@multiweb/reactCore/bridge";
import { OWDataType } from "@multiweb/types/contracts";
import { Text } from "../Text";

const { getDateToStringFunction } = bridge;

/**
 * Vrátí správně naformátovanou hodnotu pro atribut, jehož typ souvisí s časem a datem.
 * @param value Hodnota atributu.
 * @param type Typ atributu.
 * @param displayFormat Formát, v jakém má být hodnota zobrazena.
 * @param interactive Určuje, zda je komponenta vizuálně aktivní a zda s ní lze pracovat.
 * @param hasBackgroundAttr Určuje, zda je komponenta obalena uvnitř BackgroundAttr, ze kterého má převzít barvu pozadí
 */
export const displayDate = (
    value: any,
    type: OWDataType.date | OWDataType.dateTime | OWDataType.time,
    displayFormat: string | null = null,
    interactive?: boolean,
    ellipsis?: boolean,
) => {
    let displayValue = "";
    if (value instanceof Date) {
        switch (type) {
            case OWDataType.dateTime:
                displayValue = getDateToStringFunction(displayFormat ?? "").format(value);
                break;
            case OWDataType.date:
                displayValue = getDateToStringFunction(displayFormat ?? "dd").format(value);
                break;
            case OWDataType.time:
                displayValue = getDateToStringFunction(displayFormat ?? "t").format(value);
                break;
        }
    }
    return <Text value={displayValue} disabled={!interactive} {...{ ellipsis }} />;
};
